{
  "downloadIos": "Download for iPhone",
  "downloadAndroid": "Download for Android"
}
